export default __webpack_public_path__ + "static/media/ticket_1.351302f6.svg";